import type { ComponentPropsWithoutRef, ReactNode, Ref } from 'react'

import { cn } from '@gto/ui/cn'

import { groupedFieldVariants } from './grouped-field.styles'

export type GroupedFieldDescriptionProps = ComponentPropsWithoutRef<'p'> & {
  /** Helper text for the grouped controls. */
  children?: ReactNode
  /** Additional CSS class names. */
  className?: string
  /** React 19 ref prop. */
  ref?: Ref<HTMLParagraphElement>
}

export const Description = ({ className, ref, ...props }: GroupedFieldDescriptionProps) => {
  const { description } = groupedFieldVariants()

  return (
    <p
      ref={ref}
      className={cn(description(), className)}
      {...props}
    />
  )
}
